// extracted by mini-css-extract-plugin
module.exports = {"app":"_app_app__ufG_s","noSpacing":"_app_noSpacing__sUinx","appComponent":"_app_appComponent__1jAWF","fade":"_app_fade__bn89T","spacing":"_app_spacing__CrwD9"};